// components/HowDisgoWorksModal.js
import React from 'react';
import { View, Text, TouchableOpacity, Modal, Image, Dimensions } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { fontFamily } from '../../constants/fonts';
import { colors } from '../../constants/theme';

const { width: W } = Dimensions.get('window');

function HowDisgoWorksModal({ isVisible, onClose }) {
    return (
        <Modal
            animationType="fade"
            transparent={true}
            visible={isVisible}
            onRequestClose={onClose}
        >
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <View style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)' }} />
                <View style={{ backgroundColor: colors.white, width: W * 0.8, padding: 24, borderRadius: 8 }}>
                    <TouchableOpacity onPress={onClose} style={{ position: 'absolute', top: 16, right: 16, zIndex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <Ionicons name="close" size={24} color="black" />
                    </TouchableOpacity>
                    <Text style={{ fontSize: 24, fontFamily: fontFamily.abhayaBold, color: colors.black }}>How Disgo Works</Text>
                    <View style={{ marginTop: 16, flexDirection: 'row', alignItems: 'center' }}>
                        <Ionicons name="checkmark-circle" size={24} color="black" />
                        <Text style={{ fontSize: 14, marginLeft: 8, fontFamily: fontFamily.abhaya, color: colors.black }}>Find the Disgo NFC tag</Text>
                    </View>
                    <View style={{ marginTop: 8, flexDirection: 'row', alignItems: 'center' }}>
                        <Ionicons name="checkmark-circle" size={24} color="black" />
                        <Text style={{ fontSize: 14, marginLeft: 8, fontFamily: fontFamily.abhaya, color: colors.black }}>Click check-in above and tap your phone to the tag</Text>
                    </View>
                    <View style={{ marginTop: 8, flexDirection: 'row', alignItems: 'center' }}>
                        <Ionicons name="checkmark-circle" size={24} color="black" />
                        <Text style={{ fontSize: 14, marginLeft: 8, fontFamily: fontFamily.abhaya, color: colors.black }}>Reward yourself and be taken care of by the amazing team</Text>
                    </View>
                    <View style={{ marginTop: 8, flexDirection: 'row', alignItems: 'center' }}>
                        <Ionicons name="phone-portrait-outline" size={24} color="black" />
                        <Text style={{ fontSize: 14, marginLeft: 8, fontFamily: fontFamily.abhaya, color: colors.black }}>If you love this place, don’t forget to share with your friends and get rewarded for that as well!</Text>
                    </View>
                    <View style={{ marginTop: 16, flexDirection: 'row' }}>
                        <Image source={require('../../assets/DisgoNfcIcon.png')} style={{ marginLeft: -16 }} />
                        <Image source={require('../../assets/DisgoBrownLogo.png')} style={{ marginLeft: 4, borderRadius: 16 }} />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

export default HowDisgoWorksModal;
